/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
    export class Contato {
        public static inicializar() {
            var contato = new App.Contato();
            contato.inicializarEventos();
        }
    }
}

namespace App {
    export class Contato {
      private ajax: IAjax;
      private eleFormularioContato: JQuery = $("#formLinkPagamento");
      private seletorModalContato: string = "#contato";

        public inicializarEventos() {
          let objgrecaptcha = new Grecaptcha();
          objgrecaptcha.inicializar();
          this.aoIniciarEnviarContato();
        }

        private aoIniciarEnviarContato() {
          this.eleFormularioContato.on('submit', (e) => { this.aoEnviar(e); });
        }

        private aoEnviar(e: JQueryEventObject) {
          this.ajax = new App.Ajax();
          this.ajax.postModal(e, this.seletorModalContato);
        }

    }
}
